// extracted by mini-css-extract-plugin
export var iconContainer = "style-module--iconContainer--19SDG";
export var xxsmall = "style-module--xxsmall--6v3SJ";
export var xsmall = "style-module--xsmall--2gUq4";
export var small = "style-module--small--3Ny8k";
export var normal = "style-module--normal--1l_CV";
export var medium = "style-module--medium--1Tr2i";
export var large = "style-module--large--34bUh";
export var xlarge = "style-module--xlarge--2hX3e";
export var icon = "style-module--icon--3JyQD";